import { LYNX_TENANT } from '../actionTypes';

export const fetchLynxTenantDetails = (action) => ({
  type: LYNX_TENANT.FETCH_LYNX_TENANT_DETAILS,
  payload: action.payload,
});

export const addInternalLynxTenantDetail = (action) => ({
  type: LYNX_TENANT.ADD_INTERNAL_LYNX_TENANT_DETAILS,
  payload: action.payload,
});

export const fetchInternalLynxTenantDetails = (action) => ({
  type: LYNX_TENANT.FETCH_INTERNAL_LYNX_TENANT_DETAILS,
  payload: action.payload,
});

export const updateInternalLynxTenantDetail = (action) => ({
  type: LYNX_TENANT.UPDATE_INTERNAL_LYNX_TENANT_DETAILS,
  payload: action.payload,
});

export const deleteInternalLynxTenantDetail = (action) => ({
  type: LYNX_TENANT.DELETE_INTERNAL_LYNX_TENANT_DETAILS,
  payload: action.payload,
});
